import dayjs from "dayjs";
import { createSlice } from "@reduxjs/toolkit";
import quartOfYear from "dayjs/plugin/quarterOfYear";
dayjs.extend(quartOfYear);

export interface MainSliceType {
  mainDate: Date;
  mainQuarterDate: Date;
  mainHalfYearDate: Date;
  tabNavList: {
    label: string;
    value: string;
    regUrl: string;
    active: boolean;
  }[];
}
export const MainSlice = createSlice({
  name: "MainSlice",
  initialState: {
    tabNavList: [
      { label: "全部收入", value: "all", regUrl: "allIncome", active: true },
      {
        label: "绩效工资",
        value: "pSalary",
        regUrl: "detailIncome/salePerformance",
        active: false,
      },
      {
        label: "项目激励",
        value: "spInspire",
        regUrl: "specialInspire",
        active: false,
      },
    ],
    mainDate: new Date(),
    mainQuarterDate: dayjs().endOf("quarter").toDate(),
    mainHalfYearDate: dayjs().month() < 6 ? dayjs().month(5).endOf("month").toDate() : dayjs().month(11).endOf("month").toDate(),
  },
  reducers: {
    updateMainDate(state, action) {
      state.mainDate = action.payload;
    },
    updateMainQuarterDate(state, action) {
      state.mainQuarterDate = action.payload;
    },
    updateMainHalfYearDate(state, action) {
      state.mainHalfYearDate = action.payload;
    },
    updatetabNavList(state, action) {
      state.tabNavList = action.payload;
    },
  },
});

const { actions, reducer } = MainSlice;
export const { updateMainDate, updateMainQuarterDate, updateMainHalfYearDate, updatetabNavList } =
  actions;
export default reducer;
